module.exports = __webpack_public_path__ + "static/satmanAnim-f35793f4c06797f37d2799c96f7697b4.gif";